import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { backdropClose } from '../lib/modalBackdrop';

interface Props {
  isGroup: boolean;
  otherName: string;
  onConfirm: (pinForAll: boolean) => void;
  onCancel: () => void;
}

/** Подтверждение закрепления — как в Telegram: один диалог, галочка выбирает область
 *  ("для меня" по умолчанию / "для меня и собеседника"/"у всех участников группы"). */
export default function PinConfirmModal({ isGroup, otherName, onConfirm, onCancel }: Props) {
  const { t } = useTranslation('misc');
  const [pinForAll, setPinForAll] = useState(false);
  const label = isGroup ? t('pinGroup') : t('pinBoth', { name: otherName });

  return (
    <div className="modal-backdrop" {...backdropClose(onCancel)}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 360 }}>
        <h2>{t('pinTitle')}</h2>
        <p style={{ margin: '0 0 14px', fontSize: 15 }}>{t('pinQuestion')}</p>
        <label className="pin-modal-checkbox">
          <input type="checkbox" checked={pinForAll} onChange={(e) => setPinForAll(e.target.checked)} />
          <span>{label}</span>
        </label>
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 18 }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel}>{t('pinCancel')}</button>
          <button type="button" className="btn" onClick={() => onConfirm(pinForAll)}>{t('pinAction')}</button>
        </div>
      </div>
    </div>
  );
}
